import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useAuth = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getToken = () => localStorage.getItem('token');

  const getUser = (): any => {
    const user = localStorage.getItem('user');
    if (user) {
      const usrData = JSON.parse(user);
      return usrData;
    }
    return undefined;
  };

  const isAuthenticated = (): boolean => {
    const token = getToken();
    return !!token;
  };

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(isAuthenticated());

  const setAuthToken = (token: string | undefined) => {
    if (token) {
      localStorage.setItem('token', token);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem('token');
    }
  };

  const setAuthUser = (user: string | undefined) => {
    if (user) {
      localStorage.setItem('user', user);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem('user');
    }
  };

  const invalidateUser = () => {
    setAuthToken(undefined);
    setAuthUser(undefined);
    setIsLoggedIn(false);
    navigate(location.pathname);
  };

  return {
    setAuthToken,
    setAuthUser,
    invalidateUser,
    getToken,
    isAuthenticated,
    getUser,
    isLoggedIn,
  };
};

export default useAuth;
